module.exports = __webpack_public_path__ + "img/rounds-sample.678ff3f8.png";